export default __webpack_public_path__ + "static/media/img5.54532a52.png";